import { css } from '@emotion/core'
import { resetNativeInput } from './input'

export const resetButton = css`
  ${resetNativeInput}
  color: black;
  background-color: transparent;
  font-weight: bold;
`
